import React from 'react'
import {Route, Routes} from 'react-router'
import {HashRouter} from 'react-router-dom'
import RegistrationPage from './routes/registration/RegistrationPage'
import MainPageRoute from './routes/main/MainPageRoute'
import MainPage from './routes/main/MainPage'
import DefaultPageRoute from './routes/main/DefaultPageRoute'
import ErrorPage from './layout/ErrorPage'
import Balances from './routes/account/Balances'
import Profile from './routes/account/Profile'
import Orders from './routes/account/Orders'
import ResourceUse from './routes/account/ResourceUse'
import ChangePasswordPage from './routes/registration/ChangePasswordPage'
import ActivationSuccess from './routes/registration/ActivationSuccess'
import RegistrationFinish from './routes/registration/RegistrationFinish'
import RegistrationPageRoute from './routes/main/RegistrationPageRoute'
import BatchPage from './routes/batch/BatchPage'
import BatchPageRoute from './routes/main/BatchPageRoute'
import PasswordReminderPage from './routes/registration/PasswordReminderPage'
import ContactUsPage from './routes/main/ContactUsPage'
import LoginPage from './routes/registration/LoginPage'
import UserListPage from './routes/superuser/UserListPage'
import AccountListPage from './routes/superuser/AccountListPage'
import ManualOrderPage from './routes/superuser/ManualOrderPage'
import AdvertPage from './routes/main/AdvertPage'
import ImpressPage from "./routes/main/ImpressPage";
import MainPageLayout from './layout/MainPageLayout'
import RegistrationPageLayout from './layout/RegistrationPageLayout'

const CimklinikaApp = () => (
  <HashRouter>
    <Routes>
      <Route path='/' element={<MainPageRoute component={MainPage} />} exact/>
      <Route path='/kezelo' >
          <Route path=':szolgaltatas' element={<BatchPageRoute component={BatchPage} />} />
      </Route>
      <Route path='/torzsadatok' element={<DefaultPageRoute component={Profile} />} />
      <Route path='/megrendelesek' element={<DefaultPageRoute component={Orders} />} />
      <Route path='/felhasznalasok' element={<DefaultPageRoute component={ResourceUse} />} />
      <Route path='/egyenlegek' element={<DefaultPageRoute component={Balances} />} />
      <Route path='/szuperfelhasznalo/felhasznalok' element={<DefaultPageRoute component={UserListPage} />} />
      <Route path='/szuperfelhasznalo/elofizetesek' element={<DefaultPageRoute component={AccountListPage} />} />
      <Route path='/szuperfelhasznalo/megrendeles' >
          <Route path=':accountId' element={<DefaultPageRoute component={ManualOrderPage} />} />
      </Route>
      <Route path='/jelszocsere' element={<RegistrationPageRoute component={ChangePasswordPage} />} >
        <Route path=':email?'>
            <Route path=':kod?' element={<RegistrationPageRoute component={ChangePasswordPage} />} />
        </Route>
      </Route>
      <Route path='/jelszoemlekezteto' >
        <Route path=':email?' element={<RegistrationPageRoute component={PasswordReminderPage} />} />
      </Route>
      <Route path='/regisztracio_redirect' >
        <Route path=':hibakod' element={<RegistrationPageRoute component={ActivationSuccess} />} />
      </Route>
      <Route path='/regisztracio_vege' >
        <Route path=':sikeres' element={<RegistrationPageRoute component={RegistrationFinish} />} />
      </Route>
      <Route path='/regisztracio' element={<RegistrationPageRoute component={RegistrationPage} />} />
      <Route path='/irjonnekunk' element={<RegistrationPageRoute component={ContactUsPage} />} />
      <Route path='/impresszum' element={<RegistrationPageRoute component={ImpressPage} />} />
      <Route path='/bejelentkezes' element={<RegistrationPageRoute component={LoginPage} />} />
      <Route path='/hirdetes/:id' element={<MainPageRoute component={AdvertPage} exact />} />
      <Route path='*' element={<ErrorPage />} />
    </Routes>
  </HashRouter>
)

export default CimklinikaApp
